import {
  canReceiveTransferV2,
  canSendTransfer,
  canRequestTransfer,
} from '@selectors/actions/transferActions';
import {
  TRANSFER_DETAILS_VIEW,
  TRANSFER_STATUS,
} from '@stocks/StocksInventories/Transfers/utils/constants';

const isHeaderDisabled = (status, isSender) =>
  (!isSender && status >= TRANSFER_STATUS.REQUESTED) ||
  (isSender && status >= TRANSFER_STATUS.SENT);

const isSenderStoreDropdownDisabled = (senderListLength, hasSelectedSender, headerDisabled) =>
  (senderListLength <= 1 && hasSelectedSender) || headerDisabled;

const isRecipientStoreDropdownDisabled = (
  recipientListLength,
  hasSelectedRecipient,
  headerDisabled,
) => (recipientListLength <= 1 && hasSelectedRecipient) || headerDisabled;

const shouldPreventSaveOrSend = ({
  selectedSenderStore,
  selectedRecipientStore,
  date,
  status,
  supplierProductsCount,
  recipesCount,
  authorizedActions,
  transferDetailsView,
}) => {
  if (
    transferDetailsView === TRANSFER_DETAILS_VIEW.RECEPTION &&
    !canReceiveTransferV2(authorizedActions)
  ) {
    return true;
  }

  if (
    transferDetailsView === TRANSFER_DETAILS_VIEW.DELIVERY &&
    !canSendTransfer(authorizedActions)
  ) {
    return true;
  }

  if (
    transferDetailsView === TRANSFER_DETAILS_VIEW.DRAFT &&
    !canRequestTransfer(authorizedActions)
  ) {
    return true;
  }

  if (status > TRANSFER_STATUS.SENT) {
    return true;
  }

  if (supplierProductsCount === 0 && recipesCount === 0) {
    return true;
  }

  return !selectedSenderStore || !selectedRecipientStore || !date;
};

export default {
  isHeaderDisabled,
  isSenderStoreDropdownDisabled,
  isRecipientStoreDropdownDisabled,
  shouldPreventSaveOrSend,
};
